import { Accordion } from "components/DesignSystem/Accordion/Accordion";
import Async from "components/DesignSystem/AsyncComponents/Async";
import {
  TaskConnectBankCardContent,
  TaskConnectBankCardTrigger,
} from "components/TaskConnectBank";
import { BANK_ACCOUNT_STATUS } from "constants/dataSource";
import { useGetEntityBanksQuery } from "store/apis/bankConnections";

export const ReviewTaskConnectBank = ({
  groupId,
  entityId,
  openAccordionByDefault = true,
  date,
}: {
  groupId: string;
  entityId: string;
  openAccordionByDefault?: boolean;
  date: string;
}) => {
  const {
    data: banksAccounts,
    isLoading,
    isSuccess,
  } = useGetEntityBanksQuery(
    { entityId, groupId },
    { skip: !entityId || !groupId }
  );

  const accounts = banksAccounts?.accounts || [];

  const banksAccountsGroupByBank = accounts.reduce(
    (acc: { [key: string]: typeof accounts }, curr) => {
      const bankName = curr.bank_brand.name;
      if (!acc[bankName]) {
        acc[bankName] = [];
      }
      acc[bankName].push(curr);
      return acc;
    },
    {}
  );

  return (
    <Async.Root
      {...{
        isLoading: isLoading,
        isSuccess: isSuccess,
        isEmpty: banksAccounts?.accounts?.length === 0,
      }}
    >
      <Async.Empty>
        <></>
      </Async.Empty>
      <Async.Success>
        <Accordion.Root
          defaultValue={
            openAccordionByDefault ? Object.keys(banksAccountsGroupByBank) : []
          }
          type="multiple"
          className="t-flex t-flex-col t-gap-4 t-w-full"
        >
          {Object.entries(banksAccountsGroupByBank).map(([name, accounts]) => {
            const totalBankBalance = accounts?.reduce((acc, { account }) => {
              return account.status === BANK_ACCOUNT_STATUS.CLOSED
                ? acc
                : acc + account.current_balance;
            }, 0);

            const totalBankDisconnected = accounts.filter(
              (account) => !account.is_bank_connected
            ).length;
            const totalBankConnected = accounts.filter(
              (account) => account.is_bank_connected
            ).length;

            return (
              <Accordion.Item value={name} key={name}>
                <Accordion.Trigger>
                  <TaskConnectBankCardTrigger
                    totalBankConnected={totalBankConnected}
                    name={name}
                    totalBankDisconnected={totalBankDisconnected}
                    totalBankBalance={totalBankBalance}
                    date={date}
                    accountsCount={accounts.length}
                    isPreview
                  />
                </Accordion.Trigger>
                <Accordion.Content>
                  <div className="t-flex t-flex-col t-gap-3">
                    {accounts.map(({ account, is_bank_connected }) => {
                      const accountBalance = account.current_balance || 0;
                      return (
                        <TaskConnectBankCardContent
                          key={account.uuid}
                          account={account}
                          isBankConnected={is_bank_connected}
                          accountBalance={accountBalance}
                          isPreview
                        />
                      );
                    })}
                  </div>
                </Accordion.Content>
              </Accordion.Item>
            );
          })}
        </Accordion.Root>
      </Async.Success>
    </Async.Root>
  );
};
